<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Batch Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Batch Report",
      items: [
        {
          text: "Home",
        },
         {
          text: "OVR",
        },
        {
          text: "Batch Report",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>